<div class="container-fluid">
      
    <div class="row mt-3 d-flex justify-content-center signup-card vertical-centering">
        
        <div class="col-lg-3 col-xs-12 col-sm-12 col-md-4 ">
            <div class="text-center pb-4"> <img src="assets/images/logo.png" width="120"> </div> 
            <div class="text-center box">
                <h3 class="pt-3 pb-3 login-ui">Login</h3>
                <div class="card-body pt-0">
                    <p class="text-left ft-size-14"><b>Enter login details  </b></p>
                    <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
                        
                       
                     
                        <div class="col-12">
                            <div class="form-group row d-flex align-items-center">
                                
                                <div class="col-12 mobile-number">
                                    <input class="form-control"     placeholder="Login ID"    formControlName="username" required> 
                                </div>
                            </div>
                        </div>

                    
                       
                        <div class="col-12">
                            <div class="form-group row d-flex align-items-center mt-3">
                                <div class="col-12 mobile-number">
                                    <input class="form-control"     placeholder="Password"   type="password" value=""  formControlName="password" required>
                                </div>
                            </div>
                        </div> 
                        
                        <div class="text-right">
                            <button class="btn btn-continue font-15-bold mt-1" type="submit"  >Login</button>
                        </div> 
                        <br />
                        <div  *ngIf="this.isSubmitting && f.username.errors" class="alert alert-danger">
                            <div *ngIf="loginForm.controls['username'].errors.required">
                            Login ID is required.
                          </div>
                        </div>
                        <div  *ngIf="this.isSubmitting && f.password.errors" class="alert alert-danger">
                            <div *ngIf="loginForm.controls['password'].errors.required">
                            Password is required.
                          </div>
                        </div>
                        

                          <div *ngIf="this.apiisSubmitting" class="alert alert-danger">
                                {{ this.errors | translate }}
                          </div>
                        
                    </form>
                </div>
            </div>
        </div>
       
    </div>
 
  
</div>
